export default {"src":"/_next/static/media/garantieannulation.479b6286.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};